module.exports = __webpack_public_path__ + "static/img/mouth_10.47b8d49.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/mouths/thumbnail/mouth_10.png
// module id = uMNg
// module chunks = 0